import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

export type SegmentChatContextType = {
  segmentChatStatus: boolean;
  setSegmentChatStatus: Dispatch<SetStateAction<boolean>>;
};

export const SegmentChatContext = createContext<SegmentChatContextType>({
  segmentChatStatus: false,
  setSegmentChatStatus: () => {},
});
